import { getApps, initializeApp } from 'firebase/app'
import {
  connectAuthEmulator,
  getAuth,
  signInWithCustomToken as firebaseSignInWithCustomToken,
  signInWithEmailAndPassword,
  signOut,
} from 'firebase/auth'

import {
  firebaseApiKey,
  firebaseAuthDomain,
  firebaseEmulating,
  firebaseEmulatorHost,
  firebaseProjectId,
} from '@company/config'

const firebaseConfig = {
  apiKey: firebaseApiKey,
  authDomain: firebaseAuthDomain,
  projectId: firebaseProjectId,
}

// Initialize Firebase
const apps = getApps()
const firebaseApp = apps.length === 0 ? initializeApp(firebaseConfig) : apps[0]

export const authApp = getAuth(firebaseApp)
if (process.env.NODE_ENV !== 'production' && firebaseEmulating) {
  connectAuthEmulator(authApp, firebaseEmulatorHost)
}

export const getToken = async () => {
  const { currentUser } = authApp
  if (currentUser) {
    const token = await currentUser.getIdToken()
    return token
  }
  return null
}

export const firebaseLogout = async () => {
  await signOut(authApp)
}

export const signInEmailAndPassword = async (email: string, password: string) => {
  return await signInWithEmailAndPassword(authApp, email, password)
}

// 元の名前でもexport（後方互換性）
export const sighInEmailLink = signInEmailAndPassword

/**
 * Firebase カスタムトークンでサインインする。
 * LINE ログインコールバック時に ExchangeLineLogin RPC から受け取ったトークンを渡す。
 */
export const signInWithCustomToken = async (customToken: string) => {
  return await firebaseSignInWithCustomToken(authApp, customToken)
}

/**
 * Firebase Auth の初期化完了（認証状態の最初の解決）を待つ。
 * authApp.authStateReady() が Firebase SDK v9.22+ で利用可能。
 * コールバックルートで currentUser を即時参照する前に必ず呼ぶこと。
 */
export const waitForAuthStateReady = (): Promise<void> => {
  return authApp.authStateReady()
}
